import { type ReferralDetails } from "../../types";
import { BaseReferralStatusCard } from "./BaseReferralStatusCard";

interface NoPendingReferralsCardProps {
  outgoingReferralDetails: ReferralDetails;
}

export function NoPendingReferralsCard(props: NoPendingReferralsCardProps) {
  const { outgoingReferralDetails } = props;

  return (
    <BaseReferralStatusCard
      intent="neutral"
      title="You have no active referrals."
      description={
        outgoingReferralDetails.bonusAmount > 0
          ? `Ask a friend to send you their referral link, and when you ${outgoingReferralDetails.workRequirementMessage}, you'll both get a $${outgoingReferralDetails.bonusAmount} bonus.`
          : ""
      }
      illustration="complete-profile"
    />
  );
}
